import { Sex } from 'models/Animals';
import { Director } from 'models/Directors';

export const directors: Director[] = [
  {
    name: 'Jacqueline Franco',
    position: 'Presidente',
    electedIn: '19/02/2026',
    mandateExpiration: '18/02/2028',
    sex: Sex.FEMALE,
  },
  {
    name: 'Thiago Aparecido de Brito',
    position: 'Vice-Presidente',
    electedIn: '19/02/2026',
    mandateExpiration: '18/02/2028',
    sex: Sex.MALE,
  },
  {
    name: 'Andrea Cristina Picoli',
    position: '1ª Secretária',
    electedIn: '19/02/2026',
    mandateExpiration: '18/02/2028',
    sex: Sex.FEMALE,
  },
  {
    name: 'Matheus Carlos da Silva',
    position: '2° Secretário',
    electedIn: '19/02/2026',
    mandateExpiration: '18/02/2028',
    sex: Sex.MALE,
  },
  {
    name: 'Márcia Cristina Trincha',
    position: '1ª Tesoureira',
    electedIn: '19/02/2026',
    mandateExpiration: '18/02/2028',
    sex: Sex.FEMALE,
  },
  {
    name: 'Lucas Carlos da Silva',
    position: '2° Tesoureiro',
    electedIn: '19/02/2026',
    mandateExpiration: '18/02/2028',
    sex: Sex.MALE,
  },
  {
    name: 'Bruna Turati Picoli',
    position: 'Diretora Social e de Relações Públicas',
    electedIn: '19/02/2026',
    mandateExpiration: '18/02/2028',
    sex: Sex.FEMALE,
  },
];
